import { derived, writable } from "svelte/store";
import "./explore/atrium";
import "./explore/start";
import { introStart } from "./intro/context";
const internalSecondsStore = writable({ time: 0, paused: true });
let interval = null;
function unpause() {
    internalSecondsStore.update(state => {
        if (!state.paused)
            return state;
        interval = setInterval(() => {
            internalSecondsStore.update(state => (Object.assign(Object.assign({}, state), { time: state.time + 1 })));
        }, 1000);
        return Object.assign(Object.assign({}, state), { paused: false });
    });
}
function pause() {
    if (!interval)
        return;
    internalSecondsStore.update(state => {
        if (state.paused)
            return state;
        clearInterval(interval);
        return Object.assign(Object.assign({}, state), { paused: true });
    });
}
export const timeStore = {
    subscribe: internalSecondsStore.subscribe,
    pause,
    unpause
};
export const pausedStore = derived(timeStore, ({ paused }) => paused);
export const fetchedStateStore = writable({
    character: "black",
    backstories: {},
    alibis: {},
    timeline: {}
});
export const characterStore = derived(fetchedStateStore, state => state === null || state === void 0 ? void 0 : state.character);
const otherCharacterTimeline = derived([timeStore, fetchedStateStore], ([timeState, fetchedState]) => {
    var _a;
    return ({
        time: timeState.time,
        timeline: (_a = fetchedState === null || fetchedState === void 0 ? void 0 : fetchedState.timeline) !== null && _a !== void 0 ? _a : {}
    });
});
const otherCharacterStateInternal = writable({});
otherCharacterTimeline.subscribe(({ time, timeline }) => {
    otherCharacterStateInternal.update(otherCharacterState => {
        Object.entries(timeline).forEach(([character, characterTimeline]) => {
            const step = characterTimeline[time];
            if (step !== undefined)
                otherCharacterState[character] = step;
        });
        return otherCharacterState;
    });
});
export const otherCharacterStateStore = { subscribe: otherCharacterStateInternal.subscribe };
const characterTimelineInternal = writable({});
const characterStateInternal = writable({
    location: "atrium",
    action: "not doing much",
    weapon: "nothing",
    buffs: {
        wet: false,
        muddy: false,
        pretty: false,
        injured: false,
        painty: false
    },
    suspicious: false
});
function updateCharacterState(time, overrides) {
    characterStateInternal.update(state => {
        var _a, _b, _c, _d, _e;
        const action = (_a = overrides.action) !== null && _a !== void 0 ? _a : state.action;
        const location = (_b = overrides["location"]) !== null && _b !== void 0 ? _b : state.location;
        const weapon = (_c = overrides.weapon) !== null && _c !== void 0 ? _c : state.weapon;
        const suspicious = (_d = overrides.suspicious) !== null && _d !== void 0 ? _d : false;
        const buffs = Object.assign(Object.assign({}, state.buffs), (_e = overrides.buffs) !== null && _e !== void 0 ? _e : {});
        const newState = { action, location, weapon, buffs, suspicious };
        characterTimelineInternal.update(timeline => {
            timeline[time] = newState;
            return timeline;
        });
        return newState;
    });
    if (overrides.roomFlags) {
        roomFlagsStore.update(flags => {
            Object.entries(overrides.roomFlags).forEach(([room, roomFlags]) => {
                flags[room] = Object.assign(Object.assign({}, flags[room]), roomFlags);
            });
            return flags;
        });
    }
}
export function updateState(overrides) {
    return (state) => {
        characterStateStore.update(state.explore.time, overrides);
    };
}
export const characterStateStore = {
    subscribe: characterStateInternal.subscribe,
    update: updateCharacterState
};
export const setCharacterState = characterStateStore.update;
export const roomFlagsStore = writable({
    kitchen: {
        lookAround: false,
        cooking: false,
        pantry: false,
        cupboards: false,
        stolenRecipe: false,
        chalkBoard: false
    },
    dining: {
        lookAround: false,
        cabinets: false,
        boat: false,
        paintings: false,
        cloche: false
    },
    atrium: {
        lookAround: false,
        underRug: false,
        feelFlame: false,
        sideboard: false,
        art: false
    },
    porch: {
        lookAround: false,
        smellFlowers: false,
        inspectBicycle: false,
        underBench: false
    },
    garden: {
        lookAround: false,
        graves: false,
        climbTree: false,
        fountain: false,
        vegetables: false
    },
    study: {
        lookAround: false,
        desk: false,
        globe: false,
        paperwork: false,
        chess: false,
        blunder: false,
        painting: false,
        art: false
    },
    lounge: {
        lookAround: false,
        medicine: false,
        bookcase: false,
        fish: false,
        art: false
    },
    landing: {
        lookAround: false,
        dogBed: false,
        plants: false,
        cracks: false
    },
    bathroom: {
        lookAround: false,
        toiletRoll: false,
        cabinet: false,
        window: false
    },
    secondBedroom: {
        lookAround: false,
        cobwebs: false,
        picture: false,
        textbook: false,
        toyBox: false,
        artwork: false,
        diary: false,
        dollsHouse: false,
        wardrobe: false
    },
    masterBedroom: {
        lookAround: false,
        inWardrobe: false,
        underBed: false,
        takenMoney: false,
        bedsideTables: false,
        art: false,
        mirror: false
    },
    secretPassage: {
        lookAround: false,
        gnomes: false,
    },
    balcony: {
        lookAround: false,
        telescope: false
    },
    global: {
        attemptedMurder: {
            nothing: false,
            knife: false,
            herbs: false,
            candlestick: false,
            letterOpener: false,
            ratPoison: false,
            spade: false,
            poison: false,
            sword: false,
            doll: false,
            drugs: false,
            scythe: false,
            umbrella: false,
            dogTreat: false,
            lute: false
        }
    }
});
export const nodeStore = writable(introStart);
export const userInputStore = writable({});
export const postDataStore = derived([userInputStore, characterStore, characterTimelineInternal], ([userInput, character, characterTimeline]) => ({
    name: userInput.name,
    character,
    backstory: userInput.backstory,
    alibi: userInput.alibi,
    accused: userInput.accused,
    accusedReason: userInput.accusedReason,
    timeline: characterTimeline
}));
